import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Input, Output } from '@angular/core';

/** A yes/no question on the kit dialog. Emits true to confirm, false on cancel, escape or the X. */
@Component({
    selector: 'app-confirm-dialog',
    standalone: true,
    templateUrl: './confirm-dialog.component.html',
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ConfirmDialogComponent {
    @Input() open = false;
    @Input() heading = '';
    @Input() message = '';
    @Input() confirmLabel = 'Confirm';
    @Input() cancelLabel = 'Cancel';
    @Input() icon = '';
    /** Red confirm button, for a delete or anything else that cannot be undone. */
    @Input() destructive = false;
    @Output() closed = new EventEmitter<boolean>();
}
